(function () {

  if (window.__wybotMbNavInit) return;
  window.__wybotMbNavInit = true;

  var MENU_OPEN_CLASS = 'wybot-mb-menu-open';
  var closeClickHandler = null;

  function getAnnouncementContainer() {
    return (
      document.getElementById('shopify-section-top-bar') ||
      document.getElementById('shopify-section-announcement-bar')
    );
  }

  function getAnnouncementInner() {
    var container = getAnnouncementContainer();
    if (!container) return null;
    return container.querySelector('.t4s-announcement-bar');
  }

  function getHeaderEl() {
    return document.querySelector('.t4s-section-header');
  }

  function getHeaderWrapperEl() {
    var header = getHeaderEl();
    return header ? header.querySelector('.t4s-header__wrapper') : null;
  }

  function getMenuToggleBtn() {
    return document.querySelector('.t4s-push-menu-btn.wybot-menu-toggle');
  }

  function getDrawer() {
    return document.getElementById('t4s-menu-drawer');
  }

  function keepAnnouncementVisible() {
    var container = getAnnouncementContainer();
    if (!container) return;

    container.style.setProperty('display', 'block', 'important');
    container.style.setProperty('visibility', 'visible', 'important');
    container.style.setProperty('opacity', '1', 'important');
    container.classList.remove('t4s-d-none');
    container.removeAttribute('hidden');
    container.setAttribute('aria-hidden', 'false');

    var bar = getAnnouncementInner();
    if (!bar) return;

    bar.style.setProperty('display', 'block', 'important');
    bar.style.setProperty('visibility', 'visible', 'important');
    bar.style.setProperty('opacity', '1', 'important');
    bar.classList.remove('t4s-d-none');
    bar.removeAttribute('hidden');
    bar.setAttribute('aria-hidden', 'false');
  }

  function updateViewportHeight() {
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    document.documentElement.style.setProperty('--wybot-viewport-height', vh + 'px');
  }

  function applyMenuOffset() {
    if (!document.documentElement.classList.contains(MENU_OPEN_CLASS)) return;

    keepAnnouncementVisible();
    updateViewportHeight();

    var targetHeaderEl = getHeaderWrapperEl() || getHeaderEl();
    if (!targetHeaderEl) return;

    var announcementEl = getAnnouncementContainer();
    var announcementBottom = announcementEl
      ? Math.round(announcementEl.getBoundingClientRect().bottom)
      : 0;
    var headerBottom = Math.round(targetHeaderEl.getBoundingClientRect().bottom);
    var offset = Math.max(announcementBottom, headerBottom, 60);

    var menuDraw = document.getElementById('t4s-menu-drawer');
    if (menuDraw) {
      menuDraw.style.top = offset + 'px';
      menuDraw.style.height = `calc(var(--wybot-viewport-height, 100dvh) - 55px - ${offset}px)`;
    }

    document.documentElement.style.setProperty('--wybot-header-offset', offset + 'px');
    document.documentElement.style.setProperty(
      '--wybot-announcement-height',
      (announcementEl ? Math.round(announcementEl.getBoundingClientRect().height) : 0) + 'px'
    );
    document.documentElement.style.setProperty(
      '--wybot-header-height',
      Math.round(targetHeaderEl.getBoundingClientRect().height) + 'px'
    );
  }

  function setMenuOpenState(isOpen) {
    document.documentElement.classList.toggle(MENU_OPEN_CLASS, isOpen);

    var btn = getMenuToggleBtn();
    if (btn) {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (!isOpen) {
      unbindCloseClick();
      return;
    }

    updateViewportHeight();
    keepAnnouncementVisible();
    bindCloseClick();
    applyMenuOffset();
    requestAnimationFrame(applyMenuOffset);
  }

  function closeMenuDrawer() {
    var overlay = document.querySelector('.t4s-close-overlay.is--visible');
    if (overlay) {
      overlay.click();
      return;
    }

    var drawer = getDrawer();
    if (drawer && drawer.nextElementSibling) {
      var sibling = drawer.nextElementSibling;
      if (sibling.matches('.t4s-drawer-menu__close[data-drawer-close]')) {
        sibling.click();
      }
    }
  }

  function bindCloseClick() {
    var btn = getMenuToggleBtn();
    if (!btn || closeClickHandler) return;

    closeClickHandler = function (e) {
      if (!document.documentElement.classList.contains(MENU_OPEN_CLASS)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      closeMenuDrawer();
    };

    btn.addEventListener('click', closeClickHandler, true);
  }

  function unbindCloseClick() {
    var btn = getMenuToggleBtn();
    if (!btn || !closeClickHandler) return;
    btn.removeEventListener('click', closeClickHandler, true);
    closeClickHandler = null;
  }

  function bindDrawer(drawer) {
    if (!drawer || drawer.dataset.wybotNavBound === 'true') return;
    drawer.dataset.wybotNavBound = 'true';

    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        setMenuOpenState(true);
      } else {
        setMenuOpenState(false);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    updateViewportHeight();
    setMenuOpenState(false);

    window.addEventListener('resize', function () {
      if (document.documentElement.classList.contains(MENU_OPEN_CLASS)) {
        applyMenuOffset();
      } else {
        updateViewportHeight();
      }
    });

    var drawer = getDrawer();
    if (drawer) {
      bindDrawer(drawer);
      return;
    }

    new MutationObserver(function () {
      drawer = getDrawer();
      if (drawer) bindDrawer(drawer);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
